import Splide from '@splidejs/splide';
import { Intersection } from '@splidejs/splide-extension-intersection';

export default class Slideshow {
	constructor(wrapper) {

		this.ticker 				= wrapper;
		this.type 					= wrapper.dataset.type;
		this.slides					= [... wrapper.querySelectorAll('.b-video-carousel__slide')]
		this.buttons				= [... wrapper.parentElement.querySelectorAll('.b-video-carousel__buttonsinside .btn')]
		this.playVideo 				= this.playVideo.bind(this)
		this.pauseVideo 			= this.pauseVideo.bind(this)
		this.updateButtons 			= this.updateButtons.bind(this)

		

		if( this.type === 'video' ) {

			// Store video references within each slide
			this.slides.forEach(slide => {
				slide.desktopVideo = slide.querySelector('.video__desktop');
				slide.mobileVideo = slide.querySelector('.video__mobile');
				slide.activeVideo = window.matchMedia('(max-width:768px)').matches ? 
					slide.mobileVideo : 
					slide.desktopVideo;
			});

			this.videoSlider = new Splide(wrapper, {
				type: 'fade',
				rewind: true,
				perPage: 1,
				drag: 'true',
				perMove: 1,
				padding: 0,
				pagination: false,
				arrows: false,
				autoplay: 'pause',
				interval: 6000,
				speed: 1500,
				transition: 'css',
				waitForTransition: true,
				pauseOnHover: false,
				updateOnMove: true,
				intersection: {
					inView: {
						autoplay: true,
					},
					outView: {
						autoplay: false,
					},
				},
			})

			// For each button, add an event listener to go to the corresponding slide
			this.buttons && this.buttons.forEach((button, index) => {
				button.addEventListener('mouseenter', () => {
					this.videoSlider.go(index)
				})
			})

			this.videoSlider.on( 'move', (newIndex, prevIndex) => {
				this.pauseVideo(prevIndex)
				this.playVideo(newIndex)
				this.updateButtons(prevIndex, newIndex)
			});
			this.videoSlider.on( 'intersection:out', () => {
				this.pauseVideo(this.videoSlider.index)
			});
			this.videoSlider.on( 'intersection:in', () => {
				this.playVideo(this.videoSlider.index)
			});
			this.videoSlider.mount({ Intersection })


			// Add media query listener
			const mediaQuery = window.matchMedia('(max-width:768px)');
			mediaQuery.addEventListener('change', (e) => {
				const currentIndex = this.type === 'video' ? this.videoSlider.index : 0;
				
				// Pause current video before switching
				this.pauseVideo(currentIndex);
				
				// Update activeVideo for all slides
				this.slides.forEach(slide => {
					slide.activeVideo = e.matches ? slide.mobileVideo : slide.desktopVideo;
				});
				
				// Resume playing current video if it exists
				this.playVideo(currentIndex);
			});


		} else {

			const interval = wrapper.dataset.interval ? wrapper.dataset.interval : 12000;

			new Splide(wrapper, {
				type: 'fade',
				rewind: true,
				perPage: 1,
				drag: 'true',
				perMove: 1,
				padding: 0,
				pagination: true,
				arrows: false,
				autoplay: true,
				interval: interval,
				speed: 1500,
				transition: 'css',
				waitForTransition: true,
				pauseOnHover: false,
				updateOnMove: true,
				video: {
					loop: true,
					muted: true,
					autoplay: true,
					hideControls: true,
					height: '100%',
				},
				intersection: {
					inView: {
						autoplay: true,
					},
					outView: {
						autoplay: false,
					},
				},
			}).mount({
			})

		}

	}

	playVideo(slideIndex)
	{
		const slide = this.slides[slideIndex];
		if (slide.activeVideo) {
			slide.activeVideo.play();
		}
	}

	pauseVideo(slideIndex)
	{
		const slide = this.slides[slideIndex];
		if (slide.activeVideo) {
			slide.activeVideo.pause();
		}
	}

	updateButtons(prevIndex, newIndex)
	{
		this.buttons[prevIndex].classList.remove('btn--active')
		this.buttons[newIndex].classList.add('btn--active')
	}
}
